export const getSearchIndexName = (projectClientName?: string): string =>
  projectClientName?.replace(/[\s.,]+/g, '').toLowerCase() ?? '';
